export const getWalletQueryKey = 'getWallet';

export interface UserWalletData {
  currency: string;
  lastUpdateDate: string;
  lastUpdateTime: string;
  userWallet: number;
}
